Verification status code for the `verifyCandidate` mutation.
